import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 350,
        minWidth: 300,
        height: 190,
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: theme.spacing(2),
    },
}));
const TCardSkeleton = () => {
    const classes = useStyles();
    return React.createElement(Skeleton, { height: 190, className: classes.root, variant: 'rect' });
};
export default TCardSkeleton;
